import { Button, lighten, Paper, styled } from "@mui/material";

export const StyledDropzone = {
  ExternalContainer: styled('div')(({ theme }) => ({
    display: 'flex',
  })),
  Container: styled('div')(({ theme }) => ({
    width: "100%",
    minHeight: 300,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  })),
  Button: styled(Button)(({ theme }) => ({
    marginTop: "30px",
    marginRight: "30px",
  })),
  FileContainer: styled('div')(({ theme }) => ({
    overflowY: "scroll",
    padding: "10px",
    // Que el componente se expanda hasta acomodar 3 archivos máximo.
    // Si se adjuntan más, poner una barra de scroll.
    maxHeight: "220px",
    marginBottom: "20px",
  })),
  Dropzone: styled('div', {
    // Agregamos esto para que no se tomen en cuenta otras props para el estilo
    shouldForwardProp: (prop) =>
      prop !== "isDragActive" && prop !== "isDragAccept" && prop !== "isDragReject",
  })(({ theme, isDragActive, isDragAccept, isDragReject }) => {
    let borderColor = "#a1a1a1";
    if (isDragActive) borderColor = "#2196f3";
    if (isDragAccept) borderColor = "#00e676";
    if (isDragReject) borderColor = "#ff1f4a";

    return {
      flex: 1,
      display: "flex",
      width: "60%",
      padding: "2vw",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderWidth: 3,
      borderRadius: 20,
      borderColor,
      borderStyle: "dashed",
      backgroundColor: "#f7f7f7",
      color: "#858585",
      outline: "none",
      transition: "border .24s ease-in-out",
      cursor: "pointer",
      textAlign: "center",
    }
  }),
};

export const StyledFileAttachment = {
  Paper: styled(Paper)(({ theme, adjuntosConColor }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minWidth: 0,
    columnGap: 5,
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 10,
    backgroundColor: adjuntosConColor
      ? lighten(theme.palette.tertiary.main, 0.6)
      : "white",
  })),
  Children: styled('div')(({ theme, text }) => ({
    padding: 5,
    ...(text ? {
      maxWidth: "25vw",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
      : {})
  })),
}